import APIBaseProxy from './BaseProxy';

type LikeRequest = Request | RequestInit;

/**
 * 该类继承了 Base， 同时针对 fetch 做了自己的封装， 对参数和返回值进行解析
 */
class FetchProxy extends APIBaseProxy {
  // 对应 fetch Request 对象
  private request!: LikeRequest;

  // 对应 fetch Headers 对象
  private headers!: Headers | { [key: string]: string };

  // 对应 fetch  Response 对象
  private response!: Response;

  // 处理 headers
  protected setHeaders() {
    let defaultHeaders = {};
    if (this.config.method === 'POST') {
      defaultHeaders = {
        'Content-Type': 'application/json',
      };
    }
    const headers = Object.assign(defaultHeaders, this.config.headers);
    if (typeof Headers !== 'undefined') {
      this.headers = new Headers();
      // eslint-disable-next-line no-restricted-syntax
      for (const key in headers) {
        const h = this.config.headers[key];
        if (h) {
          (this.headers as Headers).append(key, h);
        }
      }
    } else {
      this.headers = headers;
    }
  }

  protected async handleSendRequest(url: string) {
    this.setHeaders();
    this.createRequest(url);
    try {
      this.response = await this.fetch(url);
      if (!this.response) {
        return this.handleRes('error', -1, null);
      }
      if (this.response.ok) {
        const data = await this.response.json();
        const res = this.handleRes('success', this.response.status, data);
        if (this.config.method === 'GET' && this.config.useCache) {
          this.cache.set(url, JSON.stringify(res));
        }
        return res;
      }
      return this.handleRes('fail', this.response.status, null);
    } catch (error) {
      console.error(error);
      return this.handleRes('error', -1, null);
    }
  }

  private async fetch(url: string) {
    // 兼容在某些环境下 Request 对象不存在的情况
    if (typeof Request === 'undefined') {
      return fetch(url, this.request as RequestInit);
    }
    return fetch(this.request as Request);
  }

  // 创建请求
  private createRequest(url: string) {
    const requestInitOptions = {
      method: this.config.method,
      body: ['PUT', 'POST'].includes(this.config.method)
        ? this.getPostData()
        : null,
      credentials: this.getCredentials(),
      mode: this.config.mode,
      headers: this.headers,
      referrer: this.config.referer ?? '',
      referrerPolicy: this.config.referrerPolicy || 'unsafe-url',
    };
    if (typeof Request !== 'undefined') {
      this.request = new Request(url, requestInitOptions);
    } else {
      this.request = requestInitOptions;
    }
  }

  private getCredentials(): RequestCredentials {
    if (this.config.withCredentials) {
      return 'include';
    }
    return 'omit';
  }
}

export default FetchProxy;
